<template v-if="$auth.isAuthenticated">
    <b-modal ref="modal" centered @hidden="cancelModal" modal-class="modal-condensed">
        <template slot="modal-header">
            <h1>{{ Translations.sections.stations.title }}</h1>
            <div>
                <Button :empty="true" class="close-popup" @click.prevent="cancelModal">
                    {{ Translations.buttons.cancel }}
                </Button>
                <Button :empty="true" :noBorder="true" color="#d2d2d2" class="validate" @click.prevent="validate">Done</Button>
            </div>
        </template>

        <template>
            <div id="station-source" class="source-column">
                <ul>
                    <li class="header">
                        <input type="text" placeholder="Stations" class="input" v-model="searchStation">
                    </li>
                    <li v-for="station in filteredList" :key="station.uid"
                        :class="['station-source', {'active': isStationSelected(station.uid)}]"
                        @click.prevent="activateStation(station)">
                        <span>{{station.name}}</span>
                    </li>
                </ul>
            </div>
        </template>

        <template slot="modal-footer">
            <div>
                <div class="selection-container">
                    <template v-if="selectedStations.length > 0">
                        <header>{{selectedStations.length}} selected stations :</header>
                        <section>
                            <div v-for="station in selectedStationsData" @click.stop="activateStation(station)"
                                 :key="station.uid"
                                 :class="['badge', 'station-badge', 'selected']">
                                <span class="visible"><i :class="['far', 'fa-eye']"></i></span>
                                <span class="name">{{station.name}}</span>
                                <span class="selector">
                                    <i class="fas fa-trash" @click.stop="activateStation(station)"></i>
                                </span>
                            </div>
                        </section>
                    </template>
                </div>
            </div>
        </template>
    </b-modal>
</template>

<script>
    import Button from '@/components/common/Button';
    import Bootstrap from 'bootstrap-vue';
    import Translations from '@/store/translations';
    import Portlet from '@/components/common/Portlet.vue';
    import {HTTP} from '@/utils/http';
    import Apis from '@/apis/index';
    import {mapState} from 'vuex';
    import WaitingBlock from '@/components/common/WaitingBlock';
    import Constants from "@/store/constants";
    import {safeObj} from "@/utils/safeObj";

    export default {
        name: 'SelectorSources',
        components: {Portlet, Bootstrap, Button, WaitingBlock},
        computed: {
            Translations: () => Translations,
            filteredList() {
                return safeObj(this.stations) && this.stations.items.filter(station => {
                    if (this.searchStation.length === 0) return station
                    return station.name.toLowerCase().includes(this.searchStation.toLowerCase())
                })
            },
            selectedStationsData () {
                if (!this.stations || !this.stations.items) {
                    return []
                }
                return this.selectedStations.map(uid => {
                    return this.stations.items.find(station => station.uid === uid)
                })
            }
        },
        watch: {
            stationUids() { this.updateSelectedStations(); }
        },
        props: {
            stationUids: {required: true},
            noModalEdit: null,
        },
        mounted() {
            this.loadStations();
        },
        data() {
            return {
                modalState: {
                    hasSearchProcessed: false,
                    isCreationActive: false,
                    isLoadingArtists: false,
                    delayedSearch: null
                },
                isSearchActive: false,
                activeStation: null,
                stations: [],
                stationBoxes: {},
                selectedBoxes: {},
                selectedStations: [],
                stationsToSend: [],
                searchStation: ''
            };
        },
        methods: {
            // ------------------------------------------------------
            /* Start : Common Behaviour */
            // ------------------------------------------------------
            show() {
                this.searchStation = "";
                this.$refs.modal.show();
            },
            hide() {
                this.$refs.modal.hide();
                this.stationsToSend = []
            },
            edit() {
                this.show();
            },
            cancelModal() {
                this.$emit("onHidden");
                this.$refs['modal'].hide();
            },
            buildArrayToSend() {
                this.stations.items.forEach(e => {
                    if (this.selectedStations.includes(e.uid)) {
                        this.stationsToSend.push(e)
                    }
                })
            },
            validate() {
                this.buildArrayToSend();
                if (this.$route.name === 'LibraryAdvancedSearchQuery'){
                    console.log('validate', this.stationsToSend)
                    this.$emit('newValue', 'sources', this.stationsToSend);
                }
                this.hide();
                this.stationsToSend = []
            },
            // Load Stations
            async loadStations() {

                const response = await HTTP.get(Apis.station.list, {params:{pageSize:10000}});

                if (safeObj(response.data.dataItem)) {
                    this.stations = response.data.dataItem;
                }
                this.updateSelectedStations();
                this.buildArrayToSend();

                // if(this.$route.name === 'LibraryAdvancedSearchQuery'){
                //     this.$emit('newValue', 'sources', this.stationsToSend);
                // }
                this.stationsToSend = []
            },
            updateSelectedStations()
            {
                this.selectedStations = [...this.stationUids]; 
            },
            // Load StationBox
            activateStation(currentStation) {

                const idx = this.selectedStations.findIndex(e => e === currentStation.uid);
                if (idx !== -1) {
                    // found duplicate, remove it
                    this.selectedStations = this.selectedStations.filter(e => e !== currentStation.uid)
                } else {
                    this.selectedStations.push(currentStation.uid)
                }
            },
            isStationSelected(stationUid) {
                return this.selectedStations.includes(stationUid)
            }
        }
    }
</script>

<style lang="scss" scoped>

    h4 {
        font-size: 13px;
        font-weight: 600;
        letter-spacing: 0.7px;
        line-height: 1;
        margin: 0;
        padding: 0;
    }


    .search-container {
        overflow: hidden;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        justify-content: stretch;
        align-self: flex-start;
        height: calc(100vh - 160px);
    }

    .box-source-wrapper {
        position: relative;
        padding-left: 25px;

        i {
            position: absolute;
            left: 0;
            top: 5px;
        }
    }

    .search-container .search-content {
        display: flex;
        flex-grow: 1;
        flex-direction: row;
        flex-shrink: 0;
        height: 100%;
    }

    .source-column li.header {
        position: sticky;
        top: 0;
        background: #fff;
        z-index: 100;
        padding: 10px;
        border-bottom: 1px solid #dee2e6;
    }
    #station-source {
        height: 600px;
        overflow: auto;
        min-height: 600px;
    }
    #station-source.source-column {
        width: 100%;
        flex-shrink: 0;
        border-right: 1px solid #dee2e6;
    }

    #box-source.source-column {
        width: 70%;
        height: 100%;
        overflow: auto;
    }

    .search-container header {
        display: flex;
        justify-content: space-between;
        align-content: center;
        align-items: center;
        padding: 10px 15px;
        border-bottom: var(--COLOR_BORDERS) 1px solid;
    }

    .search-container header h4 {
        margin: 0;
    }

    .source-column li {
        height: auto;
        padding: 7px 10px;
        align-items: baseline;
    }

    .source-column li i {
        margin-right: 15px;
    }

    .source-column li i:hover {
        margin-right: 15px;
        color: var(--COLOR_BRAND);
    }


    .source-column li .station-label {
        font-size: 12px;
        font-weight: 600;
    }

    .source-column li i.fa-check {
        opacity: 0.1;
        transition: color 0.2s ease-in-out;
    }

    .source-column li.active i.fa-check {
        opacity: 1;
        color: var(--COLOR_BRAND);
    }

    .source-column {
        li {
            .input {
                width: 100%;
            }
        }
    }

    .station-badge {
        border-radius: 100px;
        display: inline-flex;
        padding: 5px 10px;
        color: white;
        align-items: center;
        margin: 5px;

        .name {
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            flex-shrink: 0;
            width: auto;
            margin: 0 1em;
        }
    }
</style>

